module.exports = __webpack_public_path__ + "7a121667b9a7964d36d091254047c5b8.svg";